import { default as checkEventRegisteredConfiguration } from './checkEventRegistered';
import { default as getConfiguration } from './get';
import { default as getByIdConfiguration } from './getById';
import { default as getRecommendedConfiguration } from './getRecommended';
import { default as setNotAttendCourseConfiguration } from './setNotAttendCourse';

export const configurations = [
  getConfiguration,
  getRecommendedConfiguration,
  getByIdConfiguration,
  checkEventRegisteredConfiguration,
  setNotAttendCourseConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/index.js